"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleFalsyFallback = void 0;

var handleFalsyFallback = function handleFalsyFallback(value, falsyFallback) {
  if (!value && falsyFallback !== 'passthrough') {
    if (falsyFallback === 'undefined') {
      return undefined;
    } // Only option left is null


    return null;
  }

  if (typeof value === 'number' && Number.isNaN(value)) {
    return 0;
  }

  return value;
};

exports.handleFalsyFallback = handleFalsyFallback;